
















































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import * as L from "leaflet";
import LocationsStore from "@/store/modules/Locations/LocationsStore";
import {Location} from "@/store/modules/Locations/LocationEntitiy";
import anime from 'animejs';
import {LatLng} from "leaflet";
import 'leaflet-gesture-handling';
import FirebaseConnectionStore from "@/store/modules/FirebaseConnection/FirebaseConnectionStore";
import ApiClient from "@/common/ApiClient";
import moment from 'moment'
import Utils from "@/common/Utils";

enum STATE {
    DEFAULT,
    SERVICE_EXPLAIN,
    JOIN_EXPLAIN,
    PINNING,
    JOIN_CONFIRM,
    SHOW_TWEET
}

@Component({
    components: {}
})

export default class Map extends Vue {

    private map!: L.Map;
    private tempPin!: L.Marker;
    private pins: L.Marker[] = [];
    private state: STATE = STATE.DEFAULT;

    private bookName = "";
    private bookNamePin!: L.Marker;
    private isHoverOnPin: boolean = false;

    get isDefaultState() {
        return this.state == STATE.DEFAULT;
    }

    get isServiceExplainState() {
        return this.state == STATE.SERVICE_EXPLAIN;
    }

    get isJoinExplainState() {
        return this.state == STATE.JOIN_EXPLAIN;
    }

    get isPinningState() {
        return this.state == STATE.PINNING;
    }

    get isJoinConfirmState() {
        return this.state == STATE.JOIN_CONFIRM;
    }

    get isShowTweetState() {
        return this.state == STATE.SHOW_TWEET;
    }

    private tweet: any;
    private unWatchRealtimeUpdate: Function = new Function();

    async mounted() {

        // 地図を作成
        this.map = L.map("map", {
            zoomDelta: 0.5,
            zoomSnap: 0.5,
            minZoom: 2.5,
            maxZoom: 16,
            maxBounds: [[85, 138 - 190], [-85, 138 + 190]],
            maxBoundsViscosity: 0.7,
            // @ts-ignore
            gestureHandling: true,
            gestureHandlingOptions: {
                duration: 1000,
                text: {
                    touch: "指2本で操作すると地図を移動できます",
                    scroll: "地図をズームするには、ctrlキーを押しながらスクロールしてください",
                    scrollMac: "地図をズームするには、\u2318キーを押しながらスクロールしてください"
                }
            }
        }).setView([38, 137], 4.5);

        L.tileLayer("https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png", {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);

        // 色味調整用のカバーdivを配置
        this.makeColorFilter();

        // ピンのデータが変更したら更新
        this.$watch(() => LocationsStore.locations, () => {
            this.pins.forEach(v => this.map.removeLayer(v));
            this.pins = [];

            LocationsStore.locations.forEach(v => {
                const icon = L.divIcon({
                    className: 'custom-div-icon',
                    html: "<div class='particle-container'><div class='particle particle--ripple'></div><div class='particle particle--glow'></div><div class='particle particle--dot'></div></div>",
                    iconSize: [48, 48],
                    iconAnchor: [24, 24]
                });

                const pin = L.marker(
                    [v.lat, v.lng],
                    {
                        icon: icon,
                        zIndexOffset: v.with_tweet ? 20000 : (new Date(v.date).getFullYear() != 9999) ? 10000 :  0
                    }
                ).addTo(this.map);
                const pinElement = (<any>pin.getElement()).getElementsByClassName("particle-container")[0];

                if (v.with_tweet) {
                    pinElement.classList.add('with-tweet');
                    pinElement.id = v.id;

                    pin.on('click', ((e) => {
                        this.onClickPinWithTweet(e, pinElement);
                    }));
                } else {

                    if(new Date(v.date).getFullYear() == 9999){
                        pinElement.classList.add('is-fuzkue');
                    }

                    pin.on('click', ((e) => {
                        this.onClickPin(e, pinElement);
                    }));
                }


                this.pins.push(pin);
            });

            this.map.setView([38, 138], 4.5);


            document.querySelectorAll(".particle-container").forEach((el, index) => {
                let delay = index * 100;
                this.animParticle(el, delay);
            });

        }, {immediate: true, deep: true});


        // Stateを監視
        this.$watch(() => this.state, () => {
            var animation = anime({
                targets: 'html, body',
                scrollTop: 0,
                duration: 250,
                easing: 'linear',
                autoplay: false,
                complete: () => {
                    document.body.classList.add('no-scroll');
                }
            });

            if (this.isDefaultState) {
                anime.remove('html, body');
                document.body.classList.remove('no-scroll');

                //2本指操作を有効化
                (<any>this).map.gestureHandling.enable();
            } else {
                animation.play();

                //2本指操作を無効化
                (<any>this).map.gestureHandling.disable();
            }

        });

    }

    destroyed(): void {
        this.unWatchRealtimeUpdate();
    }

    // 地図色変更用フィルタ生成
    private makeColorFilter() {
        const mapPane = document.getElementsByClassName("leaflet-map-pane")[0] as HTMLElement;
        const tilePane = document.getElementsByClassName("leaflet-tile-pane")[0] as HTMLElement;
        const colorFilter = document.createElement("div") as HTMLElement;
        colorFilter.classList.add('color_filter');
        tilePane.insertBefore(colorFilter, tilePane.children[0]);

        const moveFilter = () => {
            try {
                const mapTransformValues = mapPane.style.transform.split("(")[1].split(",");
                const filterTransformX = parseFloat(mapTransformValues[0]) * -1;
                const filterTransformY = parseFloat(mapTransformValues[1]) * -1;
                colorFilter.style.transform = "translate3d(" + filterTransformX + "px, " + filterTransformY + "px, 0px)";

                requestAnimationFrame(moveFilter)
            } catch (e) {
                // do nothing
            }
        };
        moveFilter();
    }

    // マウスやタッチされた場所から最も近いデータを返す
    private getClosestLocation(e: any): { distance: number, location: Location } | null {

        // mouse or touchされた場所を取得
        let clickPoint: L.Point = new L.Point(0, 0);
        if (e.touches) {
            const touchEvent = e as TouchEvent;
            clickPoint.x = window.pageXOffset + touchEvent.touches[0].clientX;
            clickPoint.y = window.pageYOffset + touchEvent.touches[0].clientY;
        } else {
            const mouseEvent = e as MouseEvent;
            clickPoint.x = window.pageXOffset + mouseEvent.clientX;
            clickPoint.y = window.pageYOffset + mouseEvent.clientY;
        }

        // クリック位置との距離の一覧に変換
        const locations = LocationsStore.locations
            .map(v => {
                const screenPosition = this.map.latLngToContainerPoint(new LatLng(v.lat, v.lng));
                const distance = Math.sqrt(Math.pow(screenPosition.x - clickPoint.x, 2) + Math.pow(screenPosition.y - clickPoint.y, 2));
                return {
                    distance: distance,
                    location: v,
                }
            });

        if (locations.length <= 0)
            return null;

        //  距離で昇順ソート
        locations.sort((a, b) => {
            if (a.distance > b.distance) return 1;
            if (a.distance < b.distance) return -1;
            return 0;
        });

        //  距離で一番近いやつがピンサイズ以内ならクリックとみなす
        if (locations[0].distance <= (48 / 2)) {
            return locations[0];
        } else {
            return null;
        }
    }

    // 参加するボタンおした
    private onClickJoin() {
        this.state = STATE.JOIN_EXPLAIN;
    }

    // 説明ボタンおした
    private onClickExplain() {
        this.state = STATE.SERVICE_EXPLAIN;
    }

    // 説明モーダル内の続けるボタンをおした（ピン刺し開始）
    private onClickStartPin() {
        this.state = STATE.PINNING;


        const onPinned = (e: any) => {
            const icon = L.divIcon({
                className: 'custom-div-icon',
                html: "<div class='particle-container'><div class='particle particle--ripple'></div><div class='particle particle--glow'></div><div class='particle particle--dot'></div></div>",
                iconSize: [48, 48],
                iconAnchor: [24, 24]
            });

            this.tempPin = L.marker([e.latlng.lat, e.latlng.lng], {icon: icon}).addTo(this.map);
            this.animParticle((<any>this.tempPin.getElement()).getElementsByClassName("particle-container")[0], 0);

            this.map.panTo([
                this.map.layerPointToLatLng([this.map.latLngToLayerPoint(e.latlng).x, this.map.latLngToLayerPoint(e.latlng).y + 80]).lat,
                this.map.layerPointToLatLng(this.map.latLngToLayerPoint(e.latlng)).lng
            ]);

            this.state = STATE.JOIN_CONFIRM;
            this.map.off("click", onPinned);
        };
        this.map.on("click", onPinned);
    }


    // ピン情報のDB書き込み
    private join(withTweet: boolean, tweetKey:number = -1) {
        const location: Location = {
            id: "",
            lat: this.tempPin.getLatLng().lat,
            lng: this.tempPin.getLatLng().lng,
            date: new Date(),
            with_tweet: withTweet,
            tweet_key: tweetKey
        };

        LocationsStore.add(location);

        this.state = STATE.DEFAULT;
        this.map.removeLayer(this.tempPin);
    }


    // ツイートして参加をおした
    private onClickJoinWithTweet() {
        const key = Math.floor(Math.random() * 1000000000);
        this.join(true , key);

        setTimeout(() => {
            const url = "https://twitter.com/intent/tweet?text=%0a%23フヅクエ時間 %40fuzkue %0ahttps://fuzkue.com/fuzkuehour?no=" + key;
            const option = "status=1,width=824,height=400,top=100,left=100";
            window.open(url, 'twitter', option)
        }, 100)
    }

    // ツイートせずに参加をおした
    private onClickJoinWithoutTweet() {
        this.join(false);
    }

    private backToJoinConfirm() {
        this.state = STATE.JOIN_CONFIRM;
    }

    private backToPinning() {
        this.state = STATE.PINNING;
        this.map.removeLayer(this.tempPin);
        this.map.setView([38, 138], 4.5);
        this.onClickStartPin();
    }

    private onClickQuit() {

        if (this.tempPin) {
            this.map.removeLayer(this.tempPin);
            this.map.setView([38, 138], 4.5);
        }

        this.state = STATE.DEFAULT;

    }

    private onClickPin(__e: any, __el: any) {
        this.animParticle(__el, 0);
    }

    private async onClickPinWithTweet(__e: any, __el: any) {
        this.animParticle(__el, 0);

        // getパラメータに持っているキーが一致するツイートを探す
        const targetLocation = LocationsStore.locations.filter(v => v.id == __el.id)[0];
        const targetTweetKey = targetLocation.tweet_key;
        if(targetTweetKey == null)
            return;

        const apiResult = await ApiClient.serachTweetByHashtag("フヅクエ時間", 20);
        const tweets = apiResult.statuses;

        for (let i = 0; i < tweets.length; i++) {
            for (let j = 0; j <  tweets[i].entities.urls.length ; j++) {
                const targetUrl = tweets[i].entities.urls[j].expanded_url;
                if(targetUrl.indexOf(targetTweetKey.toString()) >= 0){
                    this.tweet = tweets[i];
                    this.state = STATE.SHOW_TWEET;
                }
            }
        }
    }

    private animParticle(__target: any, __delay: number): void {

        let dot = __target.querySelector(".particle--dot");
        let glow = __target.querySelector(".particle--glow");
        let ripple = __target.querySelector(".particle--ripple");

        anime.set(dot, {
            scale: 0.1
        });

        anime.set(glow, {
            scale: 0.5,
            opacity: 0
        });

        anime.set(ripple, {
            scale: 0,
            opacity: 1,
            visibility: "visible"
        });

        anime({
            targets: dot,
            scale: 1,
            duration: 1000,
            delay: __delay,
            easing: 'easeOutCirc',
        });

        anime({
            targets: glow,
            scale: 1,
            opacity: 1,
            duration: 1000,
            delay: 150 + __delay,
            easing: 'easeOutCirc',
        });

        anime({
            targets: ripple,
            scale: 1,
            opacity: 0,
            duration: 2000,
            delay: 150 + __delay,
            easing: 'easeOutCirc',
            complete: () => {
                anime.set(ripple, {
                    visibility: "hidden"
                });
            }
        });
    }

    private tweetText2Html(__tweet: any): string {
        return Utils.tweetText2Html(__tweet);
    }

    private getFormatedDate(date: string): string {
        return moment(date).format("M月D日 HH:mm");
    }

}

